export function relocationGetProductsByLocationValidate(products){
    return (
    Array.isArray(products.data) &&
    products.data.every(item =>
      typeof item === 'object' &&
      item !== null &&
      'product_id' in item &&
      'sku' in item &&
      'detailed_stocks' in item && 
      item.detailed_stocks.every(ds => 
        ds !== null &&
        'reference' in ds &&
        'batch' in ds &&
        'pallet' in ds &&
        'box' in ds &&
        'quantity' in ds
      )
    )
  )
}